import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/apiClient";
import useSeo from "@/hooks/useSeo";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false));
  }, [slug]);

  useSeo({
    title: post?.title,
    description: post?.excerpt,
    image: post?.cover_image,
    path: `/blog/${slug}`,
  });

  if (post === null) return <div className="py-24 text-center">Loading...</div>;
  if (post === false) return <div className="py-24 text-center">Post not found. <Link to="/blog" className="link-underline">Back to blog</Link></div>;

  return (
    <div className="max-w-[900px] mx-auto px-6 py-16" data-testid="blog-post-page">
      <Link to="/blog" className="overline text-neutral-500 mb-4 inline-block hover:text-black">← Back to Journal</Link>
      <div className="overline text-[color:var(--vt-orange)] mb-3">{post.category}</div>
      <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter mb-4">{post.title}</h1>
      <div className="text-sm text-neutral-500 mb-8">By {post.author} · {new Date(post.created_at).toLocaleDateString()}</div>
      <div className="aspect-[16/9] overflow-hidden mb-8">
        <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
      </div>
      <div className="prose prose-neutral max-w-none text-lg leading-relaxed text-neutral-800 whitespace-pre-line">
        {post.content}
      </div>
    </div>
  );
}
